import { EqualityMappaturaAllarmi, MappaturaAllarmiType, Mapping } from "@/api";
import {
  Box,
  Button,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function ModelloDispositivoMappaturaEqualityDialog({
  equality,
  onChange,
}: {
  equality: EqualityMappaturaAllarmi | null | undefined;
  onChange: (
    event: React.SyntheticEvent | null,
    equality: EqualityMappaturaAllarmi | null | undefined
  ) => void;
}) {
  const { t } = useTranslation();
  const [elements, setElements] = useState<Mapping[]>(
    equality?.mappings || [{ value: null, message: null } as Mapping]
  );

  const addElement = () => {
    setElements([...elements, { value: null, message: null } as Mapping]);
  };

  const removeElement = (index: number) => {
    const newElements = elements.filter((_, i) => i !== index);
    setElements(newElements);
    onChangeElements(null, newElements);
  };

  const onChangeElements = (event:  React.SyntheticEvent | null, newElements: Mapping[]) => {
    onChange(event, { type: MappaturaAllarmiType.Equality, mappings: newElements });
  };

  return (
    <div>
      {elements.map((element, index) => (
        // Horizontal 2 elements gravity left space 8px
        <Box
          key={index}
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Box display="flex" flexDirection="column" mr={1}>
            <InputLabel>{t("mappaturaEqualityDialog.campi.valore")}</InputLabel>
            <TextField
              value={element.value}
              onChange={(event) => {
                const newElements = [...elements];
                const value = event.target.value;

                if (value) {
                  newElements[index].value = value;
                  setElements(newElements);
                  onChangeElements(null, newElements);
                } else {
                  newElements[index].value = null;
                  setElements(newElements);
                  onChangeElements(null, newElements);
                }
              }}
            />
          </Box>

          <Box display="flex" flexDirection="column" mr={1}>
            <InputLabel>{t("mappaturaEqualityDialog.campi.messaggio")}</InputLabel>
            <TextField
              value={element.message}
              onChange={(event) => {
                const newElements = [...elements];
                newElements[index].message = event.target.value;
                setElements(newElements);
                onChangeElements(null, newElements);
              }}
            />
          </Box>

          <Grid item mt={3}>
            <IconButton
              onClick={() => {
                removeElement(index);
              }}
              aria-label={t("azioni.elimina")}
              style={{ color: "red" }}
            >
              <Icon>delete_outlined</Icon>
            </IconButton>
          </Grid>
        </Box>
      ))}
      <Button onClick={addElement}>
        {t("mappaturaEqualityDialog.azioni.aggiungi")}
      </Button>
    </div>
  );
}

export default ModelloDispositivoMappaturaEqualityDialog;
